import {Box} from '@mui/material';
import {FC} from 'react';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import {AdminDashboard} from './AdminDashboard';

export const Dashboard: FC = () => {
  const [, windowHeight] = useWindowDimensions();

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: `${windowHeight - 124}px`,
        margin: '20px 0',
        width: '100%',
      }}
    >
      <AdminDashboard />
    </Box>
  );
};
